/**
 * @fileoverview Detect the browsers capabilities for Web RTC, and give simple answers to complex
 * questions like "Can this browser make a video call?"
 */

import { createLogger } from '@telia-ace/edge-log';
import DetectRTC from 'detectrtc';

const log = createLogger('chat-api/checkVideoSupport');

function isVideoSupported(disabledUserAgents = []) {
  return new Promise((resolve, reject) => {
    try {
      if (isUserAgentDisabled(disabledUserAgents)) {
        resolve(false);
      }
      DetectRTC.load(() => {
        // According to DetectRTC github page, hasSpeakers might be false even though there
        // is audio output. The only browsers to be trusted when saying false are Chrome and Edge.
        // This is not very well documented, though.

        const userAgentIsSupported = !(DetectRTC.browser.isEdge || DetectRTC.browser.isIE);

        log.debug('DetectRTC:', DetectRTC);
        log.debug('userAgentIsSupported:', userAgentIsSupported);

        let hasSpeakers = DetectRTC.hasSpeakers;
        if (!hasSpeakers && !browserIsOneOf(DetectRTC.browser.name, ['Chrome', 'Edge'])) {
          hasSpeakers = true;
          log.debug('Browser can not detect if speakers work, so we assume it does.');
        }

        // Even if there is no camera, "video" calls shall be allowed.
        // They client will, of course, only send audio.
        const callSupported = DetectRTC.isWebRTCSupported && DetectRTC.hasMicrophone && hasSpeakers;
        log.debug('callSupported:', callSupported);

        const videoSupported = callSupported && userAgentIsSupported;
        log.debug('videoSupported:', videoSupported);

        resolve(videoSupported);
      });
    } catch (err) {
      log.warn('DetectRTC. Error when checking for video support, error: ', err);
      reject(err);
    }
  });
}

// From config_services.js, video chat might be disabled for certain User Agent strings.
// The configurations is an array of regexps, like ['android', 'linux']
function isUserAgentDisabled(disabledUserAgents) {
  const userAgent = window.navigator.userAgent.toLowerCase();
  let disabled = false;
  if (disabledUserAgents && disabledUserAgents.length) {
    disabledUserAgents.forEach((ua) => {
      const re = new RegExp(ua, 'i');
      if (re.test(userAgent)) {
        log.debug('Video disabled for useragent:', userAgent, disabledUserAgents);
        disabled = true;
      }
    });
  }
  return disabled;
}

function browserIsOneOf(browserName, browserList) {
  return browserList.includes(browserName);
}

export default isVideoSupported;
